var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fa-icon',{staticClass:"has-text-danger",attrs:{"icon":"exclamation-circle"}})
}
var staticRenderFns = []

export { render, staticRenderFns }